import { useContext } from 'react';

import { EnvConfigContext } from '../context/EnvConfigContext';

export function useEnvConfig() {
  return useContext(EnvConfigContext);
}
